var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"small":"","striped":"","hover":"","selectable":"","items":_vm.turboSettings,"fields":_vm.fieldsTurboSettings},on:{"row-clicked":_vm.rowTurboModeClickHandler}}),_vm._v(" "),_c('modal-ok-cancel',{attrs:{"size":"md"},on:{"save":_vm.saveTurboMode,"cancel":_vm.hideTurboMode}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71afb749","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/users/usersAndGroups/detail/serviceLinks/formTurboMode.vue
// module id = null
// module chunks = 